import { render, staticRenderFns } from "./summaryJRB.vue?vue&type=template&id=337e270c"
import script from "./summaryJRB.vue?vue&type=script&lang=js"
export * from "./summaryJRB.vue?vue&type=script&lang=js"
import style0 from "./summaryJRB.vue?vue&type=style&index=0&id=337e270c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports